/**封装常用的方法 */
class StringUtil {
  constructor() {}

  //1. 判断是否是一个空对象
  isObjectEmpty(obj) {
    for (var key in obj) {
      if (key) {
        return false
      }
    }
    return true
  };

  IsString(v) {
    return Object.prototype.toString.apply(v) === '[object String]';
  };

  // 返回文件扩展名(小写) 如果文件名有问题则返回null
  getFileExt(fileName) {
    if (fileName == null || "" === fileName) {
      return null;
    }
    let dotIdx = fileName.lastIndexOf(".");
    if (dotIdx < 0) {
      return null;
    }
    return fileName.substring(dotIdx + 1).toLowerCase();
  };

}

export default new StringUtil();